import { atom, selector } from 'recoil';

// License info from server
export const licenseAtom = atom({
  key: 'license',
  default: {
    isValid: false,
    status: 'none',
    type: null,
    expiresAt: null,
  },
});

// License loading state
export const licenseLoadingAtom = atom({
  key: 'licenseLoading',
  default: true,
});

// License error state
export const licenseErrorAtom = atom({
  key: 'licenseError',
  default: null,
});

// Selector for checking if license is valid
export const isLicenseValidSelector = selector({
  key: 'isLicenseValid',
  get: ({ get }) => {
    const license = get(licenseAtom);
    return license?.isValid === true;
  },
});

// Selector for read-only mode (inverse of valid license)
export const isReadOnlySelector = selector({
  key: 'isReadOnly',
  get: ({ get }) => {
    const license = get(licenseAtom);
    return license?.isValid !== true;
  },
});

// Selector for license status text
export const licenseStatusSelector = selector({
  key: 'licenseStatus',
  get: ({ get }) => {
    const license = get(licenseAtom);
    return license?.status || 'none';
  },
});

// Selector for checking if license is expiring soon (within 30 days)
export const isLicenseExpiringSoonSelector = selector({
  key: 'isLicenseExpiringSoon',
  get: ({ get }) => {
    const license = get(licenseAtom);
    if (!license?.expiresAt || !license?.isValid) return false;

    const expiresAt = new Date(license.expiresAt);
    const now = new Date();
    const daysUntilExpiry = Math.ceil((expiresAt - now) / (1000 * 60 * 60 * 24));

    return daysUntilExpiry > 0 && daysUntilExpiry <= 30;
  },
});

// Selector for days until expiry
export const daysUntilExpirySelector = selector({
  key: 'daysUntilExpiry',
  get: ({ get }) => {
    const license = get(licenseAtom);
    if (!license?.expiresAt) return null;

    const expiresAt = new Date(license.expiresAt);
    const now = new Date();
    return Math.ceil((expiresAt - now) / (1000 * 60 * 60 * 24));
  },
});
